<template>
  <v-header />
  <router-view />
  <v-footer />
</template>

<script>
import header from "./components/header.vue";
import footer from "./components/footer.vue";
import * as monaco from "monaco-editor";

export default {
  name: "app",
  components: {
    "v-header": header,
    "v-footer": footer,
  },
  created() {
    //自定义提示函数

    function createDependencyProposals(range) {
      return [
        {
          label: "doo3d.lookCamera",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.lookCamera();",
          detail: "将主相机移动到指定的观看位置",
          range: range,
        },
        {
          label: "doo3d.moveCamera",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.moveCamera();",
          detail: "将主相机移动到指定的位置并对准观看点",
        },
        {
          label: "doo3d.resetCamera",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.resetCamera();",
          detail: "重置相机",
        },
        {
          label: "doo3d.addPOI",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addPOI({});",
          detail: "addPOI创建POI数据点",
        },
        {
          label: "doo3d.updatePOI",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.updatePOI({});",
          detail: "更新指定id且已通过addPOI创建的POI数据点",
        },
        {
          label: "doo3d.delPOI",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delPOI({});",
          detail: "删除所指定的id且已通过addPOI创建的POI数据点",
        },
        {
          label: "doo3d.hidePOI",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.hidePOI({});",
          detail: "隐藏所指定的id且已通过addPOI创建的POI数据点",
        },
        {
          label: "doo3d.showPOI",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.showPOI({});",
          detail: "显示所指定的id且已通过addPOI创建的POI数据点",
        },
        {
          label: "doo3d.addVector",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addVector({});",
          detail: "添加唯一id作为标识的vector",
        },
        {
          label: "doo3d.updateVector",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.updateVector({});",
          detail: "更新指定id且已通过addvector创建的vector数据点",
        },
        {
          label: "doo3d.delVector",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delVector({});",
          detail: "通过ID删除已创建的vector",
        },
        {
          label: "doo3d.showVector",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.showVector({});",
          detail: "通过ID显示已创建的vector",
        },
        {
          label: "doo3d.hideVector",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.hideVector({});",
          detail: "通过ID隐藏已创建的vector",
        },
        {
          label: "doo3d.addHeatPoint",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addHeatPoint({});",
          detail: "通过指定位置绘制热力点",
        },
        {
          label: "doo3d.delHeatPoint",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delHeatPoint({});",
          detail: "删除指定热力点",
        },
        {
          label: "doo3d.addHeatArea",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addHeatArea({});",
          detail: "新建区域热力",
        },
        {
          label: "doo3d.delHeatArea",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delHeatArea({});",
          detail: "删除区域热力",
        },
        {
          label: "doo3d.addHeatPath",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addHeatPath({});",
          detail: "新建热力路径",
        },
        {
          label: "doo3d.delHeatPath",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delHeatPath({});",
          detail: "删除热力路径",
        },
        {
          label: "doo3d.addHeatColumn",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addHeatColumn({});",
          detail: "新建柱状热力",
        },
        {
          label: "doo3d.delHeatColumn",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delHeatColumn({});",
          detail: "删除柱状热力",
        },
        {
          label: "doo3d.addEffect()",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addEffect({});",
          detail: "根据给定位置生成指定类型和id的特效，id应具有唯一性",
        },
        {
          label: "doo3d.updateEffect",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.updateEffect({});",
          detail: "更新给定id对应的特效",
        },
        {
          label: "doo3d.delEffect",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delEffect({});",
          detail: "销毁给定id对应的特效",
        },
        {
          label: "doo3d.measureStart",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.measureStart({scale:0.1});",
          detail: "测量工具开始",
        },
        {
          label: "doo3d.measureStop",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.measureStop();",
          detail: "测量工具结束",
        },
        {
          label: "doo3d.measureClear",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.measureClear();",
          detail: "测量工具清理",
        },
        {
          label: "doo3d.measurePoint",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.measurePoint();",
          detail: "测量点",
        },
        {
          label: "doo3d.measureLine",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.measureLine();",
          detail: "测量距离",
        },
        {
          label: "doo3d.measureArea",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.measureArea();",
          detail: "测量面积",
        },
        {
          label: "doo3d.addModel",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addModel({});",
          detail: "新增模型",
        },
        {
          label: "doo3d.delModel",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delModel({});",
          detail: "删除模型",
        },
        {
          label: "doo3d.addLayer",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addLayer({});",
          detail: "新增图层",
        },
        {
          label: "doo3d.delLayer",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delLayer({});",
          detail: "删除图层",
        },
        {
          label: "doo3d.hideLayer",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.hideLayer({});",
          detail: "隐藏图层",
        },
        {
          label: "doo3d.attachLayer",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.attachLayer({});",
          detail: "附加图层",
        },
        {
          label: "doo3d.detachToLayer",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.detachToLayer({});",
          detail: "脱离图层",
        },
        {
          label: "doo3d.updateLayer",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.updateLayer({});",
          detail: "更新图层",
        },
        {
          label: "doo3d.addWindow",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addWindow({});",
          detail: "新增三维窗口",
        },
        {
          label: "doo3d.delWindow",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delWindow({});",
          detail: "删除三维窗口",
        },
        {
          label: "doo3d.hideWindow",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.hideWindow({});",
          detail: "隐藏图层",
        },
        {
          label: "doo3d.updateWindow",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.updateWindow({});",
          detail: "更新窗口",
        },
        {
          label: "doo3d.addOutLine",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addOutLine({});",
          detail: "根据参数paths提供的坐标点集绘制建筑外围轮廓",
        },
        {
          label: "doo3d.delOutLine",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delOutLine({});",
          detail: "根据参数id删除对应建筑外围轮廓线",
        },
        {
          label: "doo3d.addCircularOutLine",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addCircularOutLine({});",
          detail: "按照给定的圆心和半径绘制圆形轮廓",
        },
        {
          label: "doo3d.delCircularOutLine",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delCircularOutLine({});",
          detail: "根据参数id删除对应建筑外围轮廓线",
        },
        {
          label: "doo3d.addText",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.addText({});",
          detail: "创建3D文本",
        },
        {
          label: "doo3d.updateText",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.updateText({});",
          detail: "更新3D文本",
        },
        {
          label: "doo3d.delText",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.delText({});",
          detail: "删除3D文本",
        },
        {
          label: "doo3d.showText",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.showText({});",
          detail: "显示3D文本",
        },
        {
          label: "doo3d.openBuild",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.openBuild({});",
          detail: "通过楼栋id和楼层id进行楼栋展开",
        },
        {
          label: "doo3d.resetBuild",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.resetBuild({});",
          detail: "通过楼栋id重置该已展开的楼栋",
        },
        {
          label: "doo3d.regVectorEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.regVectorEvent(id=>{console.log(id);});",
          detail: "注册Vector事件",
        },
        {
          label: "doo3d.regBuildEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.regBuildEvent(id=>{console.log(id);});",
          detail: "注册楼栋回调事件",
        },
        {
          label: "doo3d.regAnimationEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.regAnimationEvent(data=>{console.log(data);});",
          detail: "注册动画回调事件",
        },
        {
          label: "doo3d.regVersionEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText:
            "doo3d.regVersionEvent(version=>{console.log(version);});",
          detail: "注册版本号事件",
        },
        {
          label: "doo3d.regCoordsEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.regCoordsEvent(data=>{console.log(data);});",
          detail: "注册二维三维坐标转换事件",
        },
        {
          label: "doo3d.regPOIEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.regPOIEvent(id=>{console.log(id);});",
          detail: "注册POI事件",
        },
        {
          label: "doo3d.regEffectEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.regEffectEvent(id=>{console.log(id);});",
          detail: "注册Effect事件",
        },
        {
          label: "doo3d.regCiradianEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.regCiradianEvent(state=>{console.log(state);});",
          detail: "注册昼夜切换事件",
        },
        {
          label: "doo3d.regModelEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText:
            "doo3d.regModelEvent((id,event)=>{console.log(id,event);});",
          detail: "注册模型事件",
        },
        {
          label: "doo3d.regGeomEvent",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText:
            "doo3d.regGeomEvent((id,event)=>{console.log(id,event);});",
          detail: "注册几何体事件",
        },
        {
          label: "doo3d.cmd",
          kind: monaco.languages.CompletionItemKind.Function,
          insertText: "doo3d.cmd({});",
          detail: "直接调用引擎方法，用于定制化扩展",
        },
      ];
    }

    // 注册monaco代码提示
    monaco.languages.registerCompletionItemProvider("javascript", {
      provideCompletionItems(model, position) {
        var word = model.getWordUntilPosition(position);
        var range = {
          startLineNumber: position.lineNumber,
          endLineNumber: position.lineNumber,
          startColumn: word.startColumn,
          endColumn: word.endColumn,
        };
        return {
          suggestions: createDependencyProposals(range),
        };
      },
      resolveCompletionItem(item, token) {
        return null;
      },
      triggerCharacters: ["d"],
    });
  },
};
</script>

<style>
@import "./assets/css/main.css";
</style>